<template>
    <div>
        <Row>
        <i-col span="22">  
        </i-col>
        <i-col span="2">
            <Button type="primary" @click="add"  v-if="privilegesbtn('/notice/create')">新增</Button>  
        </i-col>
    </Row>
    <Table :context="self" :data="tableData" :columns="tableColumns" stripe border></Table>
   <Modal v-model="modal">
       <div v-html="thiscontent"></div>
    </Modal>
    </div>
</template>
<script>
import { noticeindex ,deletenotice } from "../../api/noticeapi";
import privilegesbtn from "../../constant/privilegesbtn.js";
export default {
  data() {
    return {
      self: this,
      tableData: [],
      total: 0,
      page: 1,
      pagesize: 10,
      isupdte: privilegesbtn("/notice/update"),
      isdel:privilegesbtn("/notice/delete"),
      modal:false,
      thiscontent:"",
      tableColumns: [
        {
          title: "公告标题",
          key: "title",
          align: "center"
        },
        {
          title: "公告内容",
          key: "content",
          align: "center",
                    render: (h, params) => {
            return h("div", [ 
                h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    
                  },
                   style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showmodal(params.row.content);
                    }
                  }
                },
                "内容详细"
              ),
            ]);
          }
        },
        {
          title: "添加时间",
          key: "createtime",
          align: "center"
        },
        {
          title: "集团方是否接受",
          key: "receive_company",
          align: "center",
          render: (h, params) => {
            var rel = params.row.receive_company == 0 ? "否" : "是";
            return h("span", rel);
          }
        },
          {
          title: "集团方接受ID",
          key: "company_id",
          align: "center"
        },
          {
          title: "集团方接受ID",
          key: "hotel_id",
          align: "center"
        },
        
        {
          title: "酒店方是否接受",
          key: "receive_hotel",
          align: "center",
          render: (h, params) => {
            var rel = params.row.receive_hotel == 0 ? "否" : "是";
            return h("span", rel);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 250,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isupdte
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.show(params.row);
                    }
                  }
                },
                "修改"
              ),      h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: !this.isdel
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.del(params.row.id);
                    }
                  }
                },
                "删除"
              ),
            ]);
          }
        }
      ]
    };
  },
  methods: {
    privilegesbtn: privilegesbtn,
    mockTableData() {
      let para = {
        page: this.page,
        pagesize: this.pagesize
      };
      this.$Loading.start();
      noticeindex(para).then(res => {
        this.$Loading.finish();
        var Data = res.data;
        this.total = Data.message.total;
        this.tableData = Data.message.data;
      });
    },
    showmodal(content){
 this.thiscontent=content
        this.modal=true;
    },
    show(param) {
      this.$router.push({ path: "/noticeupdte", query: param });
    },
    add() {
      this.$router.push({ path: "/noticeadd" });
    },
    del(id){
      let self = this;
      this.$Modal.confirm({
        title: "公告列表",
        content: `是否删除此记录`,
        onOk: function() {
          this.$Loading.start();
          let para = { id: id };
          deletenotice(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              self.$Message.success(data.message);
              self.changePage(self.page);
            } else {
              self.$Message.error(data.message);
            }
          });
        }
      });
    },
    changePage(row) {
      this.page = row;
      this.mockTableData();
    }
  },
  mounted() {
    this.mockTableData();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/notice/index.vue